// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "./layout/Layout";

import Home from "./pages/Home";
import TennisCoaching from "./pages/TennisCoaching";
import WebDevelopment from "./pages/WebDevelopment";
import Portfolio from "./pages/Portfolio";

function App() {
  return (
    <Routes>
      {/* Layout commun */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/tennis" element={<TennisCoaching />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/portfolio" element={<Portfolio />} />
      </Route>

      {/* éventuellement des routes hors layout (404, etc.) plus tard */}
    </Routes>
  );
}

export default App;
